<template>
<div>
        <Breadcrumb v-if="categoryInfo != null || multimediaPosts"> 
            <span><router-link :to="{ path:'/'}">Početna</router-link></span>
            <span class="separetor">/</span>
            <span v-if="categoryInfo!= null && categoryInfo.postCategoryID != 0" class="" v-bind:class="{'font-weight-bolder': categoryInfo != null && categoryInfo.postSubcategoryID === 0 }"><router-link :to="{ name: 'category', params: { category: categoryInfo.postCategorySearchCode } }">{{categoryInfo.postCategory}}</router-link></span>
            <span v-if="categoryInfo != null && categoryInfo.postSubcategoryID != 0" class="separetor">/</span>
            <span v-if="categoryInfo != null && categoryInfo.postSubcategoryID != 0" v-bind:class="{'font-weight-bolder': categoryInfo != null && categoryInfo.postSubcategoryID != 0 }"><router-link :to="{ name: 'category', params: { category: categoryInfo.postCategorySearchCode , subcategory: categoryInfo.postSubcategorySearchCode } }">{{categoryInfo.name}}</router-link></span>
            <span v-if="multimediaPosts" class="font-weight-bolder"><router-link :to="{ name: 'category', params: { category: 'multimedija' } }">Multimedija</router-link></span>
        </Breadcrumb>
         <hr v-if="categoryInfo != null" class="category-line" v-bind:style="[categoryInfo != null? {borderTop: '1.5px solid' + categoryInfo.borderColor } : {}]"/>
        <section class="has-sidebar u-padding-tb-40">
        <div class="container">
             <div class="ad-728-90-above">
                 <GoogleAdSense :adSlot="'8235259266'" :width="728" :height="90"/>
            </div>  
            <div class="row" data-sticky_parent>
                <div class="col-lg-8 content-wrapper">
                    <div data-sticky_column>
                        <div class="posts-box has-cat has-load-more">
                            <div class="posts-box__top posts-box__top--auto-hight" v-bind:style="[categoryInfo != null? {borderLeft: '3px solid' + categoryInfo.borderColor } : {}]">
                                <div>
                                    <h3 v-if="searchTerm != null" class="m-0">{{ searchTerm != null? "Rezultati pretrage za: \"" + searchTerm + "\"" : "" }}</h3>
                                    <h3 v-if="categoryInfo != null" class="m-0">{{ categoryInfo != null? categoryInfo.name : ""}}</h3>
                                    <h3 v-if="multimediaPosts" class="m-0">Multimedija</h3>
                                    <h3 v-if="tagInfo != null" class="m-0">Oznaka: "{{ tagInfo.name }}</h3>
                                    <h3 v-if="searchTerm === null && categoryInfo === null && tagInfo === null && !multimediaPosts" class="m-0">Najnovije</h3>
                                </div>
                            </div>
                            <div v-if="loaded && posts.length !== 0" class="posts-list has-style-1">
                            <article v-for="post in posts" :key="post.postID" class="post-item post-item--style-1">
                                <figure>
                                     <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">
                                   <img v-lazy="post.absoluteThumbUrl" class="" v-bind:alt="post.title"></router-link>
                                </figure>
                                <div class="post-content">
                                    <div v-if="multimediaPosts" class="post-category">
                                        <ul>
                                            <li><a href="#">{{ post.hasVideo && post.hasPhotos? "FOTO / VIDEO" : post.hasPhotos? "FOTO" : post.hasVideo? "VIDEO" : "" }} </a></li>
                                        </ul>
                                    </div>
                                    <h4 class="post-title u-margin-t-10"> <router-link :to="{ name: 'read', params: { category: post.categoryCode, slug: post.searchCode, id: post.postID }}">{{ post.shortTitle != null? post.shortTitle : post.title }}</router-link></h4>
                                    <div class="post-meta">
                                        <i class="fa fa-clock-o"></i>{{ post.postDate | timeAgo }}
                                    </div>
                                </div>
                            </article>
                        </div><!--//.posts-list -->
                            <div v-if="loaded && posts.length === 0" class="posts-box__bottom">
                                <div class="posts-box__bottom__load-more">
                                    <span v-if="searchTerm != null">Nije pronađena nijedna vijest.</span>  
                                    <span v-if="categoryInfo != null">Nema vijesti u ovoj kategoriji.</span>         
                                    <span v-if="tagInfo != null">Nema vijesti s ovom oznakom.</span>                                                                                                                   
                                </div>
                            </div>
                            <div v-if="showLoadMorePosts" class="posts-box__bottom">
                                <div class="posts-box__bottom__load-more">
                                    <a href="javascript:;" v-on:click="fetchData(false)">Učitaj još vijesti...</a>
                                </div>
                            </div>
                        </div> <!--//.posts-box  -->
                    </div>
                    <div class="ad-728-90-below">
                        <GoogleAdSense :adSlot="'6922177590'" :width="728" :height="90"/>
                    </div>
                </div>
                <div class="col-lg-4 sidebar sidebar--right u-md-down-margin-t-40">
                    <div v-if="categoryInfo != null && (categoryInfo.postCategoryID === 1 || categoryInfo.postCategoryID === 12)">
                         <Poll></Poll>
                    </div> 
                    <div class="ad-300-250-sidebar-above">
                         <GoogleAdSense :adSlot="'9248640808'" :width="300" :height="250" />
                    </div> 
                    <div class="side-bar__inner" data-sticky_column>
                        <app-MostRecent :postCategoryId="categoryInfo != null? categoryInfo.postCategoryID : null" :postSubcategoryId="categoryInfo != null? categoryInfo.postSubcategoryID : null" :postCategoryBorderColor="categoryInfo != null? categoryInfo.categoryBorderColor : null" :takeCount="10"></app-MostRecent>     
                    </div>
                    <div class="ad-300-250-sidebar-below">
                         <GoogleAdSense :adSlot="'5800667610'" :width="300" :height="250" />
                    </div> 
                </div>
            </div>

        </div>
        </section>
        </div>
</template>

<script>
    import GoogleAdSense from "../components/GoogleAdSense.vue";
    import { NewsService } from '../common/api.service'
    import { TagsService } from '../common/api.service'
    import Breadcrumb from '../components/Breadcrumb'
    import MostRecent from '../components/MostRecent'
    import Poll from '../components/Poll.vue'

    export default {
        name: "News",
        components: { GoogleAdSense, appMostRecent: MostRecent, Poll, Breadcrumb },
        metaInfo() {
            return {
                title: this.searchTerm != null? "Rezultati pretrage za: \"" + this.searchTerm + "\"" :
                       this.categoryInfo != null? this.categoryInfo.name : 
                       this.multimediaPosts? "Multimedija" : 
                       this.tagInfo != null? "Oznaka \"" + this.tagInfo.name + "\"":
                       this.searchTerm === null && this.categoryInfo === null && this.tagInfo === null && !this.multimediaPosts? "Najnovije": ""
            }
        },
        data() {
            return {
                posts: [],
                categoryInfo: null,
                tagInfo: null,
                skip: 0,
                takeInit: 8,
                takeMore: 4,
                showLoadMorePosts: true,
                searchTerm: null,
                multimediaPosts: false,
                loaded: false
            }
        },
        watch: {
             $route(to, from) {
                this.posts = [];
                this.skip = 0;
                this.categoryInfo = null;  
                this.tagInfo =  null;
                this.searchTerm = null;      
                this.multimediaPosts = false;
                this.fetchData();   
            } 
        },
        created() {
            this.fetchData();   
            window.scrollTo(0, 0);
        },
        methods: {
             fetchData:  function(initial = true) {           
                var query = this.$route.query;
                var params = this.$route.params;
                if(query.pretraga)
                    this.searchTerm = query.pretraga;
                if(params.category === 'multimedija')
                    this.multimediaPosts = true;
                else if(params.category === 'ponos-bih') {
                    query.categoryId = 14;
                    query.subcategoryId = 66;
                }
                NewsService.search(query.pretraga, query.categoryId, query.subcategoryId, query.tagId, this.skip, initial? (query.categoryId && (query.categoryId === 1 || query.categoryId === 12)? this.takeInit+4:this.takeInit) : this.takeMore, this.multimediaPosts, params.category, params.subcategory)
                           .then(res => {
                               this.skip += res.data.posts.length;
                               this.posts.push(...res.data.posts);
                               this.categoryInfo = res.data.categoryInfo;
                               this.showLoadMorePosts = res.data.posts.length >= (initial? (query.categoryId && (query.categoryId === 1 || query.categoryId === 12)? this.takeInit+4:this.takeInit): this.takeMore);
                               if(query.tagId)
                               {
                                    TagsService.getById(query.tagId).then(res => this.tagInfo = res.data);
                               }
                               this.loaded = true;
                               if(!initial)
                                    document.getElementsByClassName("posts-box__bottom__load-more")[0].scrollIntoView(false);
                           });
            }
        }
    }
</script>

<style scoped>
    img {
        object-fit: cover;
        width: 100%;
        height: 27vh;
    }

    .posts-box__top--auto-hight {
        height: 70px;
    }

    .category-line {
        opacity: 0.3;
        margin: 0px;
    }
 
    .ad-728-90-above {
        margin-top: -20px;
        margin-bottom: 20px;
        text-align: center;
    }

    .ad-728-90-below {
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
    }

    .ad-300-250-sidebar-above {
        text-align: center;
        margin-bottom: 40px;
    }

    .ad-300-250-sidebar-below {
        text-align: center;
        margin-top: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/News.vue